import { colors, styled } from "../../../../../../../../stitches.config";

export const BuilderFieldWrapper = styled("div", {
  backgroundColor: colors.bgUiSurface,
  marginBottom: "8px",
  padding: "8px 16px",
  borderWidth: "1px",
  borderStyle: "solid",
  // same color as background to avoid jitter
  border: "1px solid transparent",
  borderRadius: "4px",
  cursor: "pointer",
  borderColor: colors.grey300,

  variants: {
    isSelected: {
      true: {
        borderColor: colors.borderUiFocused,
        backgroundColor: colors.bgUiInteraction,
      },
    },

    isGroupWrapper: {
      true: {
        borderColor: colors.grey300,
      },
    },

    hasError: {
      true: {
        borderColor: colors.borderUiCritical,
        backgroundColor: colors.red50,
      },
    },
  },
  compoundVariants: [
    {
      hasError: true,
      isSelected: true,
      css: {
        borderColor: colors.borderUiCritical,
        backgroundColor: colors.bgUiInteraction,
      },
    },
  ],
});
